import React, { useState } from "react";
import "./ReportDialog.scss";

const ReportDialog = ({ isOpen, onClose, onSubmit, isSubmitting, type }) => {
  const [reportReason, setReportReason] = useState("spam");

  const handleSubmit = () => {
    onSubmit(reportReason);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="report-dialog-overlay" onClick={(e) => e.target.className === "report-dialog-overlay" && onClose()}>
      <div className="report-dialog">
        <div className="report-dialog-header">
          <h2>Report {type}</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="report-dialog-content">
          <p className="report-description">Please select a reason for reporting this {type}:</p>
          
          <label className="report-option">
            <input
              type="radio"
              name="reportReason"
              value="spam"
              checked={reportReason === "spam"}
              onChange={() => setReportReason("spam")}
            />
            <span>Spam</span>
          </label>
          
          <label className="report-option">
            <input
              type="radio"
              name="reportReason"
              value="offensive"
              checked={reportReason === "offensive"}
              onChange={() => setReportReason("offensive")}
            />
            <span>Offensive content</span>
          </label>
          
          <label className="report-option">
            <input
              type="radio"
              name="reportReason"
              value="others"
              checked={reportReason === "others"}
              onChange={() => setReportReason("others")}
            />
            <span>Others</span>
          </label>
        </div>
        <div className="report-dialog-actions">
          <button className="cancel-button" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </button>
          <button 
            className="report-button" 
            onClick={handleSubmit} 
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Report"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportDialog;
